(() => {
  'use strict';
  // Detects where a visitor came from (UTM tags, ad click IDs, referring site), keeps it for the session,
  // shows the matching [data-source-line] copy, opens matching [data-open-for] panels, and records the
  // source on the cart so each order shows its landing channel.
  if (window.__dayloSource) return;
  const KEY = 'daylo_source';
  const PAGE_KEY = 'daylo_landing';
  const store = {
    get(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch (_) {} }
  };
  const classify = value => {
    const v = String(value || '').toLowerCase();
    if (!v) return null;
    if (v === 'ig' || v.includes('instagram')) return 'instagram';
    if (v === 'fb' || v === 'meta' || v.includes('facebook') || v.includes('fb.com') || v.includes('messenger')) return 'facebook';
    if (v.includes('pinterest') || v.includes('pin.it')) return 'pinterest';
    if (v.includes('youtube') || v.includes('youtu.be') || v === 'yt') return 'youtube';
    if (v.includes('tiktok') || v === 'tt') return 'tiktok';
    if (v.includes('google')) return 'google';
    if (v.includes('bing') || v.includes('duckduckgo') || v.includes('yahoo') || v.includes('ecosia') || v.includes('brave')) return 'search';
    if (v.includes('klaviyo') || v.includes('email') || v.includes('newsletter') || v.includes('shopify_email') || v.includes('mail')) return 'email';
    return 'other';
  };
  const detect = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('utm_source')) return classify(params.get('utm_source'));
    if (params.has('gclid') || params.has('gbraid') || params.has('wbraid') || params.has('gad_source')) return 'google';
    if (params.has('ttclid')) return 'tiktok';
    if (params.has('epik')) return 'pinterest';
    if (params.has('fbclid')) {
      const ref = document.referrer.toLowerCase();
      return ref.includes('instagram') ? 'instagram' : 'facebook';
    }
    if (document.referrer) {
      try {
        const host = new URL(document.referrer).hostname;
        if (host && host !== window.location.hostname && !host.endsWith('.myshopify.com') && !host.endsWith('shopify.com')) return classify(host);
      } catch (_) {}
    }
    return null;
  };
  const detected = detect();
  if (detected) {
    store.set(KEY, detected);
    store.set(PAGE_KEY, window.location.pathname);
  }
  const source = detected || store.get(KEY) || 'direct';
  window.__dayloSource = source;
  document.documentElement.dataset.source = source;

  const apply = (scope = document) => {
    scope.querySelectorAll('[data-source-line]').forEach(line => {
      const options = [...line.querySelectorAll('[data-src]')];
      const match = options.find(option => option.dataset.src.split(/\s+/).includes(source));
      const fallback = options.find(option => option.dataset.src === 'default');
      const chosen = match || fallback;
      options.forEach(option => { option.hidden = option !== chosen; });
      line.hidden = !chosen || !chosen.textContent.trim();
    });
    scope.querySelectorAll('[data-open-for]').forEach(panel => {
      if (panel.dataset.openFor.split(/\s+/).includes(source)) panel.open = true;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => apply(), { once: true });
  else apply();
  document.addEventListener('shopify:section:load', event => apply(event.target));

  // Record the landing source on the cart once per session, after the first cart change.
  if (source !== 'direct') {
    document.addEventListener('daylo:cart-updated', event => {
      const cart = event.detail?.cart;
      if (!cart || cart.item_count < 1 || store.get('daylo_source_saved') === source) return;
      if (cart.attributes && cart.attributes['Landing source'] === source) { store.set('daylo_source_saved', source); return; }
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      fetch(`${root}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Landing source': source, 'Landing page': store.get(PAGE_KEY) || '' } })
      }).then(response => { if (response.ok) store.set('daylo_source_saved', source); }).catch(() => {});
    });
  }
})();
